import { render, staticRenderFns } from "./ListadoGestion.vue?vue&type=template&id=2a4722ea"
import script from "./ListadoGestion.vue?vue&type=script&lang=js"
export * from "./ListadoGestion.vue?vue&type=script&lang=js"
import style0 from "./ListadoGestion.vue?vue&type=style&index=0&id=2a4722ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports